import React, { SyntheticEvent, useState } from 'react'
// import Quill from 'quill'

// Style
import { Input, Button, Dimmer } from 'semantic-ui-react'
import type { InputProps } from 'semantic-ui-react'

type Props = {
  active: boolean
  getQuill: () => any | undefined
  disable: () => void
}

const ImagePrompt = ({ active, getQuill, disable }: Props) => {
  const [url, setUrl] = useState('')

  const handleChange = (_e: SyntheticEvent, { value }: InputProps) => setUrl(value)

  const handleInsert = () => {
    const quill = getQuill()
    if (!quill) return
    quill.focus()
    const range = quill.getSelection()
    if (!range) return
    quill.insertEmbed(range.index, 'image', url)
    disable()
  }

  return (
    <Dimmer inverted active={active}>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Input value={url} onChange={handleChange} name="url" placeholder="Enter an image url..." />
        <Button color="green" disabled={!url} onClick={handleInsert}>
          Insert
        </Button>
        <Button color="red" onClick={disable}>
          Cancel
        </Button>
      </div>
    </Dimmer>
  )
}

export default ImagePrompt
